export var SHOW_HANDOFF = 'SHOW_HANDOFF';
export var HIDE_HANDOFF = 'HIDE_HANDOFF';
export var CHANGE_HANDOFF_SELECTED_ITEM = 'CHANGE_HANDOFF_SELECTED_ITEM';
export var CHANGE_HANDOFF_SELECTED_ITEM_BY_UUID = 'CHANGE_HANDOFF_SELECTED_ITEM_BY_UUID';
export var INCREMENT_ZOOM = 'INCREMENT_ZOOM';
export var DECREMENT_ZOOM = 'DECREMENT_ZOOM';
export var FIT_ZOOM = 'FIT_ZOOM';
export var SET_INITIAL_HANDOFF_ZOOM_FLAG = 'SET_INITIAL_HANDOFF_ZOOM_FLAG';
export var DESELECT_HANDOFF_ITEM = 'DESELECT_HANDOFF_ITEM';
export var CHANGE_HANDOFF_HOVERED_ITEM = 'CHANGE_HANDOFF_HOVERED_ITEM';
export var CHANGE_HANDOFF_HOVERED_ITEM_BY_UUID = 'CHANGE_HANDOFF_HOVERED_ITEM_BY_UUID';
export var SET_CANVAS = 'SET_CANVAS';
export var LOAD_CANVAS_STARTING = 'LOAD_CANVAS_STARTING';
export var LOAD_CANVAS_FAILED = 'LOAD_CANVAS_FAILED';
export var LOAD_CANVAS_DONE = 'LOAD_CANVAS_DONE';
export var SET_CANVAS_EASEL_URLS = 'SET_CANVAS_EASEL_URLS';
export var TOGGLE_COLUMN_OVERLAY = 'TOGGLE_COLUMN_OVERLAY';
export var TOGGLE_ROW_OVERLAY = 'TOGGLE_ROW_OVERLAY';
export var SET_UNIT = 'SET_UNIT';
export var UPDATE_ZOOM_POSITION = 'UPDATE_ZOOM_POSITION';
export var SET_PERCENTAGE_BASED_GUIDELINES = 'SET_PERCENTAGE_BASED_GUIDELINES';
export var SET_COLOR_MODE = 'SET_COLOR_MODE';
